import type { ConfigRequestBody, ConfigResponse } from "../types/chat.types";

export async function ConfigRequestService(
  body: ConfigRequestBody,
  refreshToken?: () => Promise<string>,
  _retryCount: number = 0,
): Promise<ConfigResponse> {
  const apiUrl = import.meta.env.VITE_API_URL;
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (body.accessToken) {
    headers["Authorization"] = `Bearer ${body.accessToken}`;
  }
  const fullUrl = `${apiUrl}/config`;
  const response = await fetch(fullUrl, {
    method: "POST",
    headers,
    credentials: "include",
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    // Retry once if 401 Unauthorized
    if (response.status === 401 && refreshToken && _retryCount < 1) {
      try {
        const newAccessToken = await refreshToken();
        return ConfigRequestService(
          {
            ...body,
            accessToken: newAccessToken,
          },
          refreshToken,
          _retryCount + 1,
        );
      } catch (error) {
        console.error("Failed to refresh token:", error);
        throw error;
      }
    }
    const errorText = await response.text();
    throw new Error(
      `API error: ${response.status}: ${response.statusText}\n${errorText}`,
    );
  }
  return response.json();
}
